import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const DashboardIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        id="DashboardIcon"
        data-testid="DashboardIcon"
        className="bloxicon"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="20"
      >
        <path
          fill="currentColor"
          d="M22.776.99h-4.732c-.676 0-1.224.548-1.224 1.224V8.39c0 .677.548 1.225 1.224 1.225h4.732c.676 0 1.224-.548 1.224-1.225V2.214c0-.676-.548-1.225-1.224-1.225ZM13.913.99H1.225C.548.99 0 1.537 0 2.213V8.39c0 .677.548 1.225 1.224 1.225h12.689c.676 0 1.224-.548 1.224-1.225V2.214c0-.676-.548-1.225-1.224-1.225ZM1.224 19.979h4.732c.676 0 1.224-.548 1.224-1.225v-6.176c0-.676-.548-1.224-1.224-1.224H1.224c-.676 0-1.224.548-1.224 1.224v6.176c0 .677.548 1.225 1.224 1.225ZM10.063 19.979H22.75c.676 0 1.224-.548 1.224-1.225v-6.176c0-.676-.548-1.224-1.224-1.224H10.063c-.677 0-1.225.548-1.225 1.224v6.176c0 .677.548 1.225 1.225 1.225Z"
        />
      </svg>
    </SvgIcon>
  );
};

export default DashboardIcon;
